export default "__VITE_ASSET__Boysc4Uj__"